var makeBuiltIn = {exports: {}};

export { makeBuiltIn as __module };
//# sourceMappingURL=_virtual-make-built-in.js.map
